import { MenuItemType } from "@arelia-components/ui-atoms/menu-selector/models";
import SortIcon from '@mui/icons-material/Sort';
import { CustomersSorting, SortOrderMap as SortOrderMapType, SortValueGetterMap as SortValueGetterMapType } from "./models";
import { SortOrder } from "@arelia-types/data-models";
import SortMenuLabel from "@arelia-components/ui-atoms/SortMenuLabel";

export const sortByMenu: MenuItemType<CustomersSorting>[] = [{
  label: <SortMenuLabel><SortIcon sx={{ transform: "scaleY(-1)" }} />Latest first</SortMenuLabel>,
  value: CustomersSorting.createdDateDesc
}, {
  label: <SortMenuLabel><SortIcon/>Oldest first</SortMenuLabel>,
  value: CustomersSorting.createdDateAsc
}, {
  label: <SortMenuLabel><SortIcon sx={{ transform: "scaleY(-1)" }} />Name A-Z</SortMenuLabel>,
  value: CustomersSorting.nameAsc
}, {
  label: <SortMenuLabel><SortIcon />Name Z-A</SortMenuLabel>,
  value: CustomersSorting.nameDesc
}];

export const SortOrderMap: SortOrderMapType = {
  [CustomersSorting.createdDateAsc]: SortOrder.asc,
  [CustomersSorting.createdDateDesc]: SortOrder.desc,
  [CustomersSorting.nameAsc]: SortOrder.asc,
  [CustomersSorting.nameDesc]: SortOrder.desc
};

export const SortValueGetterMap: SortValueGetterMapType = {
  [CustomersSorting.createdDateAsc]: customer => new Date(customer.createdDate),
  [CustomersSorting.createdDateDesc]: customer => new Date(customer.createdDate),
  [CustomersSorting.nameAsc]: customer => customer.displayName?.trim().toLowerCase() || "\ufff0",
  [CustomersSorting.nameDesc]: customer => customer.displayName?.trim().toLowerCase() || "\ufff0"
};